export const loadingStatus = {
  pending: 'LOADING_PENDING',
  loading: 'LOADING_LOADING',
  complete: 'LOADING_COMPLETE',
};

export const loadStatusDefaults = {
  status: null,
  success: null,
  error: null,
  result: null,
};
